// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2JYez","footer":"ModalFilter_footer__j_UdV"};